import React from "react"
import { BodyTextRegular, BodyTextSemibold } from "./typography/text"
import { css, useTheme } from "@emotion/react"
import { ButtonPrimary } from "./button/buttons"
import { useI18next } from "gatsby-plugin-react-i18next"
import { routes } from "../routes"

const countryPickerStyle = css`
  display: flex;
  flex-direction: row;
  gap: 8px;
`

// TODO: get from API
export const SUPPORTED_COUNTRIES = [
  {
    name: "All 🌍",
    code: "all",
  },
  {
    name: "Denmark 🇩🇰",
    code: "dnk",
  },
  {
    name: "Iceland 🇮🇸",
    code: "isl",
  },
  {
    name: "Norway 🇳🇴",
    code: "nor",
  },
  {
    name: "Greenland 🇬🇱",
    code: "grl",
  },
]

type Props = {
  countryCode: string
}

export const CountryPicker = ({ countryCode }: Props) => {
  const theme = useTheme()
  const { navigate } = useI18next()

  return (
    <div css={countryPickerStyle}>
      {SUPPORTED_COUNTRIES.map((country) => {
        const isSelected = country.code === countryCode
        const TextComponent = isSelected ? BodyTextSemibold : BodyTextRegular

        const buttonStyle = css`
          padding: 10px;
          background-color: ${isSelected
            ? theme.colors.ctaLight
            : theme.colors.transparent};
          color: ${isSelected ? theme.colors.ctaMain : theme.colors.primary};
          :hover {
            background-color: ${theme.colors.ctaLight};
          }
        `

        return (
          <ButtonPrimary
            key={country.code}
            width="auto"
            height="32px"
            backgroundColor={theme.colors.ctaLight}
            css={buttonStyle}
            onClick={() => {
              navigate(routes.restaurants(country.code))
            }}
          >
            <TextComponent>{country.name}</TextComponent>
          </ButtonPrimary>
        )
      })}
    </div>
  )
}
